enum ActionTypes {
  setQueryParams = 'SET_QUERY_PARAMS'
}

export default ActionTypes;
